export const GiftCardMoreAbout = ({ title, desc }: { title: string; desc: string }) => {
  return (
    <div className="product-moreAbout">
      <h3>More About </h3>
      <h4>{title}</h4>
      <div className="product-moreAbout-description" dangerouslySetInnerHTML={{ __html: desc }}></div>
    </div>
  );
};
